/**
 * Utilities for handling rebooking API request items
 */

// Counter for generating sequential item IDs
let itemIdCounter = 1;

/**
 * Reset the item ID counter
 * Call this at the beginning of each rebooking request preparation
 */
export const resetItemIdCounter = () => {
  itemIdCounter = 1;
};

/**
 * Creates an item object for the rebooking API request
 * Always includes tariff_code for all items as required by the production API
 * @param isAdditionalItem Whether this is an additional product (true) or required product (false)
 * @param itemData Item data containing properties for the API request
 * @returns Object ready to be added to the API request items array
 */
export const createRebookingItem = (isAdditionalItem: boolean, itemData: any) => {
  // Generate a simple sequential item ID if not provided
  const itemRefId = itemData.ref_id || `item_${itemIdCounter++}`;
  
  // Base item that all items need - price is NOT included as it causes validation errors
  const baseItem = {
    ref_id: itemRefId,
    passenger_ref_id: itemData.passenger_ref_id,
    segment_ref_id: itemData.segment_ref_id,
    product_code: itemData.product_code,
    // Always include tariff_code as required by production API
    tariff_code: itemData.tariff_code || itemData.product_code,
  }
  
  return baseItem;
}
